import React from "react";

export default function ImagePreviewGrid({setNewBase64, setActive, setUrlOfImage, images = [], maxHeight = 320, active, setBase64 }) {
    if (!images.length) return null;

    console.log('Active ...',active,'  ',images)

    async function getBase64FromUrl(url) {
        const res = await fetch("https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/generateBase64", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ url: url }),
        });
        const base = await res.json();
        const base64 = base.success ? base.image : null

        return base64
    }

    async function click_image(obj) {
        setActive(obj.ID)
        setUrlOfImage(obj.url)
        let base64 = await getBase64FromUrl(obj.url)
        setBase64(base64)
        setNewBase64(base64)
    }

    return (
        <div style={{ ...styles.scrollWrapper, maxHeight }}>
            <div style={styles.grid}>
                {images.map((img) => (
                  <div
  key={img.ID}
  onClick={() => click_image(img)}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-4px)";
    e.currentTarget.style.boxShadow =
      "0 12px 32px rgba(0,0,0,0.45)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "none";
    e.currentTarget.style.boxShadow =
      "0 8px 24px rgba(0,0,0,0.35)";
  }}
  style={{
    ...styles.card,
    ...(active === img.ID ? styles.cardActive : {}),
  }}
>

                        <img
                            src={img.url}
                            alt="preview"
                            style={styles.image}
                        />

                        {/* Download button */}
                        <a
                            href={img.url}
                            download
                            target="_blank"
                            rel="noreferrer"
                            style={styles.downloadBtn}
                            title="Download image"
                        >
                            ⬇
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
}


const styles = {
    scrollWrapper: {
        width: "100%",
        maxWidth: "100%",
        overflowY: "auto",
        overflowX: "hidden",        // ✅ HARD disable X scroll
        overscrollBehavior: "contain",
        scrollBehavior: "smooth",
        paddingRight: 6,
        boxSizing: "border-box",    // ✅ prevents width overflow
    },
    grid: {
        display: "grid",
        width: "100%",              // ✅ lock width
        maxWidth: "100%",
        gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
        gap: 16,
        boxSizing: "border-box",    // ✅ critical
    },

    card: {
        position: "relative",
        borderRadius: 14,
        overflow: "hidden",
        backgroundColor: "#0F1419",
        border: "1px solid #1F2937",
        boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
    },

    image: {
        width: "100%",
        height: 160,
        objectFit: "cover",
        display: "block",
    },

    downloadBtn: {
        position: "absolute",
        top: 10,
        right: 10,
        width: 34,
        height: 34,
        borderRadius: "50%",
        backgroundColor: "rgba(0,0,0,0.65)",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "none",
        fontSize: 18,
        cursor: "pointer",
        transition: "all 0.2s ease",
    },

    cardActive: {
        border: "2px solid #F7941D", // brown/orange highlight
        boxShadow: "0 0 0 1px rgba(247,148,29,0.45), 0 12px 32px rgba(0,0,0,0.45)",
    }

};
